// extracted by mini-css-extract-plugin
module.exports = {"VerticalSeparator":"VerticalSeparator_VerticalSeparator__1i019"};